import { Leaf } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#1A2E1A] text-[#F9FAF6] mt-32" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-9 h-9 rounded-full bg-[#7AC143] flex items-center justify-center text-white font-black text-lg">H</div>
            <span className="font-black text-xl">Herbalife<span className="text-[#7AC143]">Shop</span></span>
          </div>
          <p className="text-[#9DB59D] max-w-md leading-relaxed">
            Votre distributeur indépendant Herbalife. Nutrition essentielle, énergie vibrante, bien-être au quotidien.
          </p>
          <div className="mt-6 inline-flex items-center gap-2 text-sm text-[#7AC143]">
            <Leaf className="w-4 h-4" /> 100% naturel & certifié
          </div>
        </div>
        <div>
          <h4 className="font-bold mb-4 text-white">Boutique</h4>
          <ul className="space-y-2 text-sm text-[#9DB59D]">
            <li>Nutrition</li>
            <li>Boissons</li>
            <li>Promotions</li>
            <li>Édition limitée</li>
          </ul>
        </div>
        <div>
          <h4 className="font-bold mb-4 text-white">Ressources</h4>
          <ul className="space-y-2 text-sm text-[#9DB59D]">
            <li>Healthy Guides</li>
            <li>Kitchen Corner</li>
            <li><Link to="/contact" className="hover:text-[#7AC143]">Contact</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-[#9DB59D]">
        © 2026 HerbalifeShop. Distributeur indépendant. Les déclarations n'ont pas été évaluées par une autorité de santé.
      </div>
    </footer>
  );
}
